import "lightgallery.js/src/css/lightgallery.css"
import "lightgallery.js";


// https://sachinchoolur.github.io/lightgallery.js/docs/api.html
// https://sachinchoolur.github.io/lightgallery.js/docs/api.html#dynamic
export function openLightGallery(element, dynamicElements, index) {
  window.lightGallery(element, {
    dynamic: true,
    dynamicEl: dynamicElements,
    index: index,
    download: false,
  })
}
